import Highway from '@dogstudio/highway'
import { browser } from '../util/browserInfo'
import blockList from '../blocks/blockList'
import Splitting from 'splitting'
import WrapLines from '../util/WrapLines'
import store from '../store'

export default class Page extends Highway.Renderer {
  isEdge() {
    return browser.name === 'Microsoft Edge'
  }

  isIE() {
    return browser.name === 'Internet Explorer'
  }

  checkEdgeElems() {
    if (!this.isEdge()) return

    const elems = document.querySelectorAll('.checkEdge')

    for (let i = 0; i < elems.length; i++) {
        elems[i].classList.add('isEdge')
    }
  }

  checkIEElems() {
    if (!this.isIE()) return

    const elems = document.querySelectorAll('.checkIE')

    for (let i = 0; i < elems.length; i++) {
        elems[i].classList.add('isIE')
    }
  }

  isSafari() {
    return browser.name === 'Safari'
  }

  checkSafariElems() {
    if (!this.isSafari()) return

    const elems = document.querySelectorAll('.checkSafari')

    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.add('isSafari')
    }
  }

  split() {
    this.splittedEls = []

    this.els = this.view.querySelectorAll('[data-split]')

    for (let i = 0; i < this.els.length; i++) {
      this.splittedEls.push({
        dom: this.els[i],
        text: this.els[i].innerHTML
      })

      if (this.els[i].dataset.split === 'lines') {
        // eslint-disable-next-line no-new
        new WrapLines({ el: this.els[i] })
      } else {
        // eslint-disable-next-line no-new
        new Splitting({
          target: this.els[i],
          by: this.els[i].dataset.split
        })
      }
    }
  }

  onEnter(props = {}) {
    this.view = this.wrap.lastElementChild

    this.props = props

    this.checkEdgeElems()
    this.checkIEElems()
    this.checkSafariElems()

    this.blockList = blockList
    this.blocks = []
    if (this.blockList && this.blockList.length) this.initBlocks()

    this.split()
  }

  initBlocks() {
    store.isMobile && (this.blockList = this.blockList.filter((e) => e.mobile !== false))

    for (let i = 0; i < this.blockList.length; i++) {
      const foundBlocks = this.view.querySelectorAll('.' + this.blockList[i].name)
      const block = {
        name: this.blockList[i].name,
        instances: []
      }

      for (let j = 0; j < foundBlocks.length; j++) {
        const instance = {
          el: foundBlocks[j],
          class: new this.blockList[i].Class(foundBlocks[j])
        }

        block.instances.push(instance)
      }
      this.blocks.push(block)
    }
  }

  onEnterCompleted() {
    for (let i = 0; i < this.blocks.length; i++) {
      for (let j = 0; j < this.blocks[i].instances.length; j++) {
        this.blocks[i].instances[j].class.onEnterCompleted()
      }
    }
  }

  onLeave() {
    for (let i = 0; i < this.blocks.length; i++) {
      for (let j = 0; j < this.blocks[i].instances.length; j++) {
        if (!this.blocks[i].instances[j].class.destroyLast) this.blocks[i].instances[j].class.destroy()
      }
    }
  }

  onLeaveCompleted() {
    for (let i = 0; i < this.blocks.length; i++) {
      for (let j = 0; j < this.blocks[i].instances.length; j++) {
        if (this.blocks[i].instances[j].class.destroyLast) this.blocks[i].instances[j].class.destroy()
      }
    }
  }

  resize() {
    for (let i = 0; i < this.blocks.length; i++) {
      for (let j = 0; j < this.blocks[i].instances.length; j++) {
        this.blocks[i].instances[j].class.resize()
      }
    }
  }

  scroll(e) {
    for (let i = 0; i < this.blocks.length; i++) {
      for (let j = 0; j < this.blocks[i].instances.length; j++) {
        this.blocks[i].instances[j].class.scroll(e)
      }
    }
  }

  update() {
    if (this.blocks) {
      for (let i = 0; i < this.blocks.length; i++) {
        for (let j = 0; j < this.blocks[i].instances.length; j++) {
          this.blocks[i].instances[j].class.update()
        }
      }
    }
  }
}
